"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostLayout = void 0;
var PostLayout;
(function (PostLayout) {
    PostLayout["WISH_LIST"] = "WISH_LIST";
    PostLayout["SEARCH"] = "SEARCH";
    PostLayout["MY_POSTS"] = "MY_POSTS";
})(PostLayout = exports.PostLayout || (exports.PostLayout = {}));
